import React from "react";
import { API_BASE, fetchJson } from "../utils";

export default function useSetCollection() {
  const [sets, setSets] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [revision, setRevision] = React.useState(0);

  React.useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    fetchJson(`${API_BASE}/user-sets/`, { signal: controller.signal })
      .then((data) => {
        if (controller.signal.aborted) return;
        const list = data?.sets ?? data?.user_sets ?? data;
        if (!Array.isArray(list))
          throw new Error("Invalid set collection response");
        setSets(list);
      })
      .catch((failure) => {
        if (!controller.signal.aborted) setError(failure);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [revision]);

  return {
    sets,
    setSets,
    loading,
    error,
    reload: () => setRevision((v) => v + 1),
  };
}
